import { useQuery } from '@tanstack/react-query';
import {
  EconomicEvent,
  EconomicsResponse,
  financialEvents,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

import { groupEntriesByDate } from '../utils/grouping-utils';

const QUERY_KEY_ECONOMICS_EVENTS = 'QUERY_KEY_ECONOMICS_EVENTS';
export interface UseEconomicsEventsProps {
  from: string;
  to: string;
  countries?: string[];
}

export const useEconomicsEvents = ({
  from,
  to,
  countries,
}: UseEconomicsEventsProps) =>
  useQuery({
    queryKey: [QUERY_KEY_ECONOMICS_EVENTS, to, from, countries],
    queryFn: ({ signal }) => {
      const { path, schema } = financialEvents.getEconomics;
      return wretchRequest<EconomicsResponse>(path({ from, to, countries }), {
        schema,
        signal,
      });
    },
    select: data => groupEntriesByDate<EconomicEvent>(data.economics, 'date'),
  });
